// extracted by mini-css-extract-plugin
module.exports = {"container":"extracao_container__2D-MN","display":"extracao_display__2mvRI","inputFiltro":"extracao_inputFiltro__3k40O","btnCriar":"extracao_btnCriar__1AV8r"};